import {getLastElementOr} from "./array-utils";




const DIACRITICS_REGEX = new RegExp("[\\u0300-\\u036f]", "g");

export const normalizeSearchText = (text: string): string => (
    (text || "")
        .normalize("NFD")
        .replace(DIACRITICS_REGEX, "")
        .replace(/[^a-zA-Z0-9\s]/g, "")
        .toLowerCase()
        .trim()
);


export const extractErrorMessage = (e: any): string => {
    let errorMessage = JSON.stringify(e) || "Errore Generico";
    if( !!e ) {
        if( !!e.message ) {
            errorMessage = e.message;
        }
        else {
            if( !!e.error ) {
                // errorMessage = e.error;
                if( !!e.error.message ) errorMessage = e.error.message;
                else {
                    if( !!e.error.msg ) errorMessage = e.error.msg;
                    if( !!e.error.error ) {
                        // errorMessage = e.error.error;
                        if( !!e.error.error.msg ) errorMessage = e.error.error.msg;
                        if( !!e.error.error.message ) errorMessage = e.error.error.message;
                    }
                }
            }
        }
    }
    return errorMessage;
}


export const decodeUriEncodedString = str => (
    str
        .split("%0a").join("").split("%0A").join("")
        .split("%09").join("")
        .split("%20").join(" ")
        .split("%21").join("!")
        .split("%22").join(":")
        .split("%23").join("#")
        .split("%24").join("$")
        .split("%25").join("#")
        .split("%26").join("&")
        .split("%27").join("'")
        .split("%28").join("(")
        .split("%29").join(")")
        .split("%2a").join("*").split("%2A").join("*")
        .split("%2b").join("+").split("%2B").join("+")
        .split("%2c").join(",").split("%2C").join(",")
        .split("%2d").join("-").split("%2D").join("-")
        .split("%2e").join(".").split("%2E").join(".")
        .split("%2f").join("/").split("%2F").join("/")
        .split("%3a").join(":").split("%3A").join(":")
        .split("%3b").join(";").split("%3B").join(";")
        .split("%3c").join("<").split("%3C").join("<")
        .split("%3d").join("=").split("%3D").join("=")
        .split("%3e").join(">").split("%3E").join(">")
        .split("%3f").join("?").split("%3F").join("?")
        .split("%40").join("@")
        .split("%5b").join("[").split("%5B").join("[")
        .split("%5c").join("\\").split("%5C").join("\\")
        .split("%5d").join("]").split("%5D").join("]")
        .split("%5e").join("^").split("%5E").join("^")
        .split("%5f").join("_").split("%5F").join("_")
        .split("%60").join("`")
        .split("%7b").join("{").split("%7B").join("{")
        .split("%7c").join("|").split("%7C").join("|")
        .split("%7d").join("}").split("%7D").join("}")
        .split("%7e").join("~").split("%7E").join("~")
        .split("%80").join("€")
        .split("%e0").join("à").split("%E0").join("à")
        .split("%e8").join("è").split("%E8").join("è")
        .split("%e9").join("é").split("%E9").join("é")
        .split("%ec").join("ì").split("%EC").join("ì")
        .split("%f2").join("ò").split("%F2").join("ò")
        .split("%f9").join("ù").split("%F9").join("ù")


        .split("#250a").join("").split("#250A").join("")
        .split("#2509").join("")
        .split("#2520").join(" ")
        .split("#2521").join("!")
        .split("#2522").join(":")
        .split("#2523").join("#")
        .split("#2524").join("$")
        .split("#2525").join("#")
        .split("#2526").join("&")
        .split("#2527").join("'")
        .split("#2528").join("(")
        .split("#2529").join(")")
        .split("#252a").join("*").split("#252A").join("*")
        .split("#252b").join("+").split("#252B").join("+")
        .split("#252c").join(",").split("#252C").join(",")
        .split("#252d").join("-").split("#252D").join("-")
        .split("#252e").join(".").split("#252E").join(".")
        .split("#252f").join("/").split("#252F").join("/")
        .split("#253a").join(":").split("#253A").join(":")
        .split("#253b").join(";").split("#253B").join(";")
        .split("#253c").join("<").split("#253C").join("<")
        .split("#253d").join("=").split("#253D").join("=")
        .split("#253e").join(">").split("#253E").join(">")
        .split("#253f").join("?").split("#253F").join("?")
        .split("#2540").join("@")
        .split("#255b").join("[").split("#255B").join("[")
        .split("#255c").join("\\").split("#255C").join("\\")
        .split("#255d").join("]").split("#255D").join("]")
        .split("#255e").join("^").split("#255E").join("^")
        .split("#255f").join("_").split("#255F").join("_")
        .split("#2560").join("`")
        .split("#257b").join("{").split("#257B").join("{")
        .split("#257c").join("|").split("#257C").join("|")
        .split("#257d").join("}").split("#257D").join("}")
        .split("#257e").join("~").split("#257E").join("~")
        .split("#2580").join("€")
        .split("#25e0").join("à").split("#25E0").join("à")
        .split("#25e8").join("è").split("#25E8").join("è")
        .split("#25e9").join("é").split("#25E9").join("é")
        .split("#25ec").join("ì").split("#25EC").join("ì")
        .split("#25f2").join("ò").split("#25F2").join("ò")
        .split("#25f9").join("ù").split("#25F9").join("ù")






);
